import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { EMPTY_FIELD } from 'support/helpers/const/const';
import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { components } from 'support/types/schema-portal';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

type NotificationLog = components['schemas']['NotificationLog'];

type CatalogPartnerListLastRequestElementProps = {
  lastNotificationLogGroup: Array<NotificationLog> | null;
};

export const CatalogPartnerListLastRequestElement: React.FC<CatalogPartnerListLastRequestElementProps> = ({
  lastNotificationLogGroup,
}) => {
  const { t } = useTranslation();

  if (lastNotificationLogGroup && lastNotificationLogGroup.length > 0) {
    return (
      <span className="flex items-center gap-1 tabular-nums">
        {formatDayAndTime(lastNotificationLogGroup[0].created_at)}
        <Tooltip>
          <TooltipTrigger>
            <InformationCircleIcon className="mr-2 size-4 text-gray-400 hover:text-procuros-green-500" />
          </TooltipTrigger>
          <TooltipContent>
            <div>{t('priceCatalogs:partnerList.lastRequestElement.requestSentTo')}</div>
            <ul>
              {lastNotificationLogGroup.map((notification, index) => (
                <li key={index}>{notification.destination_contact}</li>
              ))}
            </ul>
          </TooltipContent>
        </Tooltip>
      </span>
    );
  }

  return EMPTY_FIELD;
};
